import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import "./News.css";
import { newsPosts } from "../../constants";
import { NewsPost } from "../../interfaces/interfaces";

const NewsGrid: React.FC = () => {
  const [selectedPost, setSelectedPost] = useState<NewsPost | null>(null);

  // Dynamic Header Blur Effect
  useEffect(() => {
    const header = document.querySelector(".header-container") as HTMLElement;
    if (header) {
      header.style.backdropFilter = `blur(20px)`;
    }
  }, []);

  // Sort news posts by date (newest first)
  const sortedNewsPosts = [...newsPosts].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  );

  return (
    <div className="news-page">
      <Helmet>
        <title>Actualités | Zied Zouari</title>
        <meta name="keywords" content="Zied Zouari, music, albums, collaborations, violinist, composer" />
      </Helmet>
      <main className="news-main">
        <div className="blog-header">
          <h1>Actualités</h1>
        </div>
        {/* List of News */}
        <section className="news-list">
          {sortedNewsPosts.map((post) => (
            <div
              key={post.id}
              className="news-item"
              onClick={() => setSelectedPost(post)}
            >
              <img src={post.imageUrl} alt={post.title} />
              <div className="item-content">
                <h3>{post.title}</h3>
                <p>{post.date}</p>
                <p>{post.category}</p>
              </div>
            </div>
          ))}
        </section>

        {/* Modal for displaying the full description */}
        {selectedPost && (
          <div className="modal-overlay" onClick={() => setSelectedPost(null)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button
                className="close-modal"
                onClick={() => setSelectedPost(null)}
              >
                ×
              </button>
              <img src={selectedPost.imageUrl} alt={selectedPost.title} />
              <h2>{selectedPost.title}</h2>
              <p>{selectedPost.description}</p>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default NewsGrid;